import * as React from 'react';
import { FixMeLater } from '../../../utils';
import { Typography, TypographyBaseProps } from '../Typography';
import { useComponentDefaultProps, TypographyBodySize } from '../../../theming';

export interface BodyProps extends TypographyBaseProps {
    size?: TypographyBodySize | 'inherit';
}

const defaultProps: Partial<BodyProps> = {
    size: 'inherit',
    component: 'p',
};

/**
 * The following is one of the essential components for the honeycomb project, it is a component which takes in string to display the text
 * to the user on the website in custom and different variant. The typography component takes in custom behaviors for the text via props and
 * displays the text in that particular manner. We can dictate the style of  the text by using properties such as color, font weight size of the text,
 * alignment, font family and further text decorations. There are multiple variants and usage of typography wrapped in its own custom component such as body,
 * heading and hero variants as you can see below.
 */
export const Body: React.ForwardRefExoticComponent<BodyProps & React.RefAttributes<HTMLElement>> = React.forwardRef(
    function Body(props: BodyProps, ref: React.ForwardedRef<FixMeLater>): React.JSX.Element {
        const { size = 'inherit', ...other } = useComponentDefaultProps('Body', defaultProps, props);

        return <Typography ref={ref} family="body" size={size} {...other} />;
    }
);
